import React, { Component } from 'react';
import logo from '../images/logo.png';

class Home extends Component {
    render() {
        return (
            <div className="container">
                <center>

                    <img src={logo} className="logo" alt="Logo Nascer" />

                    <div className="row" style={{marginTop:'15%'}}>
                        <div className="col-md-6" style={{marginBottom:'3%'}}>
                        <button type="submit" className="btn btn-block btn-success btn-home" 
                                onClick={() => {
                                    this.props.history.push({pathname:`/1`})
                                }}>
                                Formulário
                            </button>
                        </div>
                        <div className="col-md-6">
                            <button type="submit" className="btn btn-block btn-success btn-home" 
                                onClick={() => {
                                    this.props.history.push({pathname:`/admin`})
                                }}>
                                Respostas
                            </button>
                        </div>
                        
                    </div>

                </center>
            </div>
        );
    }
}

export default Home;